import React from 'react';
import { Chip } from '@mui/material';
import RemoteAutocomplete from './RemoteAutocomplete';

// Keeps an option when every typed word is in its label, which is how the backend matches the words
// (CP-6058): "pickup hilton" finds "Pickup: Hilton Union Square", which matching the whole input hid.
export const matchEveryWord = (options, { inputValue, getOptionLabel }) => {
    const words = inputValue.toLowerCase().split(/\s+/).filter(Boolean);
    if (!words.length) {
        return options;
    }
    return options.filter((option) => {
        const label = getOptionLabel(option).toLowerCase();
        return words.every((word) => label.includes(word));
    });
};

export const SystemTagsDropdown = (props) => {
    // Operators have thousands of tags: the list loads a page at a time as it scrolls, or showed
    // only the first 25 (CP-6056).
    return <RemoteAutocomplete
        disabled={props.disabled}
        multiple
        resource="system_tag"
        urlSuffix={null}
        pageSize={50}
        label={props.label || 'System tags'}
        variant={props.variant || 'filled'}
        size={props.size || 'small'}
        fullWidth
        getOptionLabel={props.getOptionLabel || ((opt) => `${opt.category.name}: ${opt.name}`)}
        onChange={props.onChange}
        filterOptions={matchEveryWord}
        filterSelected
        value={props.value || []}
        helperText={props.helperText}
        renderTags={props.renderTags || ((value, getTagProps) => value.map((tag, index) => (
            <Chip
                key={tag.id}
                {...getTagProps({ index })}
                label={
                    <a
                        href={`/tags/${tag.id}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={(e) => e.stopPropagation()}
                        style={{ textDecoration: 'none', color: 'inherit' }}
                    >
                        {`${tag.category?.name}: ${tag.name}`}
                    </a>
                }
            />
        )))}
    />;
};

export default SystemTagsDropdown;
